import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';

class Action extends React.PureComponent {
    onClick = () => {
        const { onClick, action } = this.props;
        onClick(action);
    };

    render() {
        return (
            <Button color="primary" onClick={this.onClick}>
                {this.props.action}
            </Button>
        );
    }
}

Action.propTypes = {
    action: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export default Action;



// WEBPACK FOOTER //
// ./src/components/users/Action.js